// CODE FOR ACCOUNT DROP DOWN FUNCTIONALITY

(() => {
  if (window.accountCartMenuInitialized) return;
  window.accountCartMenuInitialized = true;

  const desktop = window.matchMedia('(min-width: 1024px)');
  const hoverDesktop = window.matchMedia(
    '(min-width: 1024px) and (hover: hover) and (pointer: fine)'
  );

  const timers = new WeakMap();
  const requests = new WeakMap();

  function getMenu(button) {
    return document.getElementById(
      button.getAttribute('popovertarget')
    );
  }

  function getButton(menu) {
    return menu.closest('.header-account')
      ?.querySelector('[popovertarget]');
  }

  function isOpen(menu) {
    return menu.matches(':popover-open');
  }

  function positionMenu(button, menu) {
    const rect = button.getBoundingClientRect();
    const viewportWidth = document.documentElement.clientWidth;
    const expanded = menu.hasAttribute('data-confirming');

    const width = Math.min(
      expanded ? 360 : (desktop.matches ? rect.width : 170),
      viewportWidth - 16
    );

    menu.style.width = width + 'px';
    menu.style.left = Math.max(
      8,
      Math.min(rect.right - width, viewportWidth - width - 8)
    ) + 'px';
    menu.style.top = (rect.bottom + 8) + 'px';
    menu.style.maxHeight = Math.max(
      0,
      window.innerHeight - rect.bottom - 16
    ) + 'px';
  }

  function resetMenu(menu) {
    requests.get(menu)?.abort();
    requests.delete(menu);
    clearTimeout(timers.get(menu));

    menu.removeAttribute('data-confirming');
    menu.removeAttribute('aria-busy');

    menu.querySelector('[data-account-confirm-panel]')?.remove();

    const options = menu.querySelector('[data-account-options]');
    if (options) options.hidden = false;

    const logout = menu.querySelector('[data-account-logout]');
    if (logout) {
      logout.removeAttribute('aria-disabled');
      logout.textContent = 'Log Out';
    }
  }

  function closeMenu(menu) {
    clearTimeout(timers.get(menu));
    if (isOpen(menu)) menu.hidePopover();
  }

  // Reset the menu immediately when it closes.
  document.addEventListener('beforetoggle', (event) => {
    const menu = event.target;

    if (
      menu.matches?.('.account-popover') &&
      event.newState === 'closed'
    ) {
      resetMenu(menu);
    }
  }, true);

  function showConfirmation(menu, message) {
    const template = menu.querySelector(
      '[data-account-confirm-template]'
    );

    const panel = template.content.firstElementChild.cloneNode(true);
    panel.setAttribute('data-account-confirm-panel', '');
    const messageElement = panel.querySelector('[data-account-message]');
    const cartPhrase = message.match(/\b\d+ items? in your cart\b/);

    if (cartPhrase) {
      const phraseStart = cartPhrase.index;
      const highlightedText = document.createElement('strong');

      highlightedText.className = 'account-confirm__cart-count';
      highlightedText.textContent = cartPhrase[0];

      messageElement.replaceChildren(
        document.createTextNode(message.slice(0, phraseStart)),
        highlightedText,
        document.createTextNode(
          message.slice(phraseStart + cartPhrase[0].length)
        )
      );
    } else {
      messageElement.textContent = message;
    }

    const button = getButton(menu);

    if (desktop.matches) {
      menu.querySelector('[data-account-options]').hidden = true;
      menu.setAttribute('data-confirming', '');
      menu.appendChild(panel);
      positionMenu(button, menu);
      panel.querySelector('[data-account-close]').focus();
      return;
    }

    // Mobile: use a native modal dialog.
    closeMenu(menu);

    const dialog = document.createElement('dialog');
    dialog.className = 'account-cart-dialog';
    dialog.setAttribute('aria-label', 'Before you go');

    panel.querySelector('[data-account-message]').id =
      'AccountCartDialogMessage';
    dialog.setAttribute(
      'aria-describedby',
      'AccountCartDialogMessage'
    );

    dialog.appendChild(panel);
    document.body.appendChild(dialog);

    // Tapping the shaded area closes the popup.
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;

      const rect = dialog.getBoundingClientRect();
      const outside =
        event.clientX < rect.left ||
        event.clientX > rect.right ||
        event.clientY < rect.top ||
        event.clientY > rect.bottom;

      if (outside) dialog.close();
    });

    dialog.addEventListener('close', () => {
      dialog.remove();
      button?.focus({ preventScroll: true });
    }, { once: true });

    dialog.showModal();
  }

  async function checkCart(link, menu) {
    if (requests.has(menu)) return;

    clearTimeout(timers.get(menu));

    const controller = new AbortController();
    requests.set(menu, controller);

    menu.setAttribute('aria-busy', 'true');
    link.setAttribute('aria-disabled', 'true');
    link.textContent = 'Checking cart…';

    const timeout = setTimeout(() => controller.abort(), 10000);

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart.js', {
        credentials: 'same-origin',
        cache: 'no-store',
        signal: controller.signal
      });

      if (!response.ok) throw new Error('Cart unavailable');

      const cart = await response.json();

      if (!Number.isInteger(cart.item_count) || cart.item_count < 0) {
        throw new Error('Invalid cart count');
      }

      // Ignore responses if the customer dismissed the menu.
      if (
        requests.get(menu) !== controller ||
        !menu.isConnected ||
        !isOpen(menu)
      ) return;

      if (cart.item_count === 0) {
        window.location.assign(link.href);
        return;
      }

      const count = cart.item_count;
      const noun = count === 1 ? 'item' : 'items';

      showConfirmation(
        menu,
        `You still have ${count} ${noun} in your cart. ` +
        'Would you like to view your cart before logging out?'
      );
    } catch (error) {
      if (
        requests.get(menu) !== controller ||
        !menu.isConnected ||
        !isOpen(menu)
      ) return;

      // Keep both choices available if the cart check fails.
      showConfirmation(
        menu,
        'We couldn’t check your cart right now. ' +
        'You can continue to your cart or log out anyway.'
      );
    } finally {
      clearTimeout(timeout);

      if (requests.get(menu) === controller) {
        requests.delete(menu);
        menu.removeAttribute('aria-busy');
        link.removeAttribute('aria-disabled');
        link.textContent = 'Log Out';
      }
    }
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const close = event.target.closest('[data-account-close]');
    if (close) {
      event.preventDefault();

      const dialog = close.closest('dialog');
      if (dialog) {
        dialog.close();
      } else {
        const menu = close.closest('.account-popover');
        const button = getButton(menu);
        closeMenu(menu);
        button?.focus({ preventScroll: true });
      }
      return;
    }

    const logout = event.target.closest('[data-account-logout]');
    if (logout) {
      event.preventDefault();
      const menu = logout.closest('.account-popover');
      if (menu) void checkCart(logout, menu);
      return;
    }

    const button = event.target.closest(
      '.header-account-link[popovertarget]'
    );

    if (!button) return;

    const menu = getMenu(button);
    if (!menu) return;

    positionMenu(button, menu);

    // Preserve keyboard toggling and mobile tap behavior.
    if (hoverDesktop.matches && event.detail > 0) {
      event.preventDefault();
      if (!isOpen(menu)) menu.showPopover();
    }
  }, true);

  document.addEventListener('pointerover', (event) => {
    if (!hoverDesktop.matches || event.pointerType !== 'mouse') return;

    const account = event.target.closest('.header-account');
    const button = account?.querySelector('[popovertarget]');
    if (!button) return;

    const menu = getMenu(button);
    if (!menu) return;

    clearTimeout(timers.get(menu));
    positionMenu(button, menu);

    if (!isOpen(menu)) menu.showPopover();
  });

  document.addEventListener('pointerout', (event) => {
    if (!hoverDesktop.matches || event.pointerType !== 'mouse') return;

    const account = event.target.closest('.header-account');
    if (!account || account.contains(event.relatedTarget)) return;

    const button = account.querySelector('[popovertarget]');
    const menu = button && getMenu(button);
    if (!menu) return;

    clearTimeout(timers.get(menu));

    timers.set(menu, setTimeout(() => {
      // Keep the cart message open until explicitly dismissed.
      if (
        requests.has(menu) ||
        menu.hasAttribute('data-confirming') ||
        account.contains(document.activeElement)
      ) return;

      closeMenu(menu);
    }, 180));
  });

  window.addEventListener('resize', () => {
    document.querySelectorAll('.account-popover:popover-open')
      .forEach((menu) => {
        const button = getButton(menu);
        if (button) positionMenu(button, menu);
      });
  });

  document.addEventListener('scroll', (event) => {
    if (
      event.target instanceof Element &&
      event.target.closest('.account-popover, .account-cart-dialog')
    ) return;

    document.querySelectorAll('.account-popover:popover-open')
      .forEach((menu) => {
        if (
          requests.has(menu) ||
          menu.hasAttribute('data-confirming')
        ) {
          const button = getButton(menu);
          if (button) positionMenu(button, menu);
        } else {
          closeMenu(menu);
        }
      });
  }, true);
})();


// CODE FOR UNITS SOLD BADGE

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-units-sold]').forEach((el) => {
    const value = Number(el.dataset.unitsSold);
    el.textContent = value.toLocaleString('en-US');
  });
});

// CODE FOR BENEFITS BADGES ON PDP

document.addEventListener('DOMContentLoaded', () => {
  const benefits = document.querySelector('[data-product-benefits]');

  if (!benefits) return;

  const drawer = benefits.querySelector('.product-benefits__drawer');
  const triggers = benefits.querySelectorAll('[data-benefit-trigger]');

  // Move the drawer outside the PDP's three-column layout so it can
  // overlay the full page rather than sit underneath the Specifications column.
  document.body.appendChild(drawer);

  const closeButtons = drawer.querySelectorAll('[data-benefit-close]');
  const contentPanels = drawer.querySelectorAll('[data-benefit-content]');
  const closeButton = drawer.querySelector('.product-benefits__close');

  let activeTrigger = null;

  const openDrawer = (benefit, trigger) => {
    activeTrigger = trigger;

    contentPanels.forEach((panel) => {
      panel.hidden = panel.dataset.benefitContent !== benefit;
    });

    triggers.forEach((button) => {
      button.setAttribute(
        'aria-expanded',
        button === trigger ? 'true' : 'false'
      );
    });

    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('product-benefits-open');

    window.setTimeout(() => closeButton.focus(), 300);
  };

  const closeDrawer = () => {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('product-benefits-open');

    triggers.forEach((button) => {
      button.setAttribute('aria-expanded', 'false');
    });

    if (activeTrigger) {
      activeTrigger.focus();
    }
  };

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      openDrawer(trigger.dataset.benefitTrigger, trigger);
    });
  });

  closeButtons.forEach((button) => {
    button.addEventListener('click', closeDrawer);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });
});

// CODE FOR PCFITMENT COMPATABILITY CHART, RENAME TABLE HEADERS

  (() => {
    const labelMap = {
      BodyNumDoors: 'Doors',
      BodyType: 'Body Type'
    };

    let observer;

    const markEmptyFitmentCells = (root) => {
      const table = root.matches?.('#bc-applications')
        ? root
        : root.querySelector?.('#bc-applications');

      if (!table) return;

      const rows = Array.from(table.querySelectorAll('tr'));
      const headerRow = rows.find((row) => row.querySelector('th'));

      if (!headerRow) return;

      const fillableHeaders = new Set([
        'submodel',
        'doors',
        'bodynumdoors',
        'bodytype'
      ]);

      const fillableColumnIndexes = Array.from(headerRow.cells)
        .map((header, index) => ({
          index,
          label: header.textContent
            .trim()
            .toLowerCase()
            .replace(/\s+/g, '')
        }))
        .filter(({ label }) => fillableHeaders.has(label))
        .map(({ index }) => index);

      rows.forEach((row) => {
        if (!row.querySelector('td')) return;

        fillableColumnIndexes.forEach((columnIndex) => {
          const cell = row.cells[columnIndex];

          if (cell) {
            cell.classList.toggle(
              'pc-fitment-fits-all',
              !cell.textContent.trim()
            );
          }
        });
      });
    };

    const addFitsAllDisplayStyles = () => {
      if (document.querySelector('#pc-fitment-fits-all-styles')) return;

      const style = document.createElement('style');
      style.id = 'pc-fitment-fits-all-styles';
      style.textContent = `
        td.pc-fitment-fits-all::before {
          content: 'Fits All';
        }
      `;

      document.head.appendChild(style);
    };

    const renameFitmentLabels = (root) => {
      if (!root) return;

      addFitsAllDisplayStyles();
      markEmptyFitmentCells(root);

      const textWalker = document.createTreeWalker(
        root,
        NodeFilter.SHOW_TEXT
      );

      const textNodes = [];

      while (textWalker.nextNode()) {
        textNodes.push(textWalker.currentNode);
      }

      textNodes.forEach((textNode) => {
        const originalLabel = textNode.nodeValue.trim();

        if (labelMap[originalLabel]) {
          textNode.nodeValue = textNode.nodeValue.replace(
            originalLabel,
            labelMap[originalLabel]
          );
        }
      });
    };

    const initializeFitmentLabelRenaming = () => {
      const fitmentChart =
        document.querySelector('#Applications') ||
        document.querySelector('#fitmentApplicationsWrapper') ||
        document.querySelector('#bc-applications');

      if (!fitmentChart) return false;

      renameFitmentLabels(fitmentChart);

      if (observer) observer.disconnect();

      observer = new MutationObserver(() => {
        renameFitmentLabels(fitmentChart);
      });

      observer.observe(fitmentChart, {
        childList: true,
        subtree: true
      });

      return true;
    };

    document.addEventListener('DOMContentLoaded', () => {
      if (initializeFitmentLabelRenaming()) return;

      const pageObserver = new MutationObserver(() => {
        if (initializeFitmentLabelRenaming()) {
          pageObserver.disconnect();
        }
      });

      pageObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  })();

// CODE FOR PCFITMENT COMPATABILITY CHART ON MOBILE

(() => {
  const labelMap = {
    BodyNumDoors: 'Doors',
    BodyType: 'Body Type'
  };

  const fitsAllHeaders = new Set([
    'Submodel',
    'Doors',
    'BodyNumDoors',
    'BodyType',
    'Body Type'
  ]);

  const generatedTableSelector = '#pc-fitment-transposed-table-wrapper';

  const renderTransposedFitmentTable = () => {
    const applications = document.querySelector('#Applications');
    const sourceTable = document.querySelector('#bc-applications');
    const wrapper = document.querySelector('#fitmentApplicationsWrapper');

    if (!applications || !sourceTable || !wrapper) return;

    const existingTable = wrapper.querySelector(generatedTableSelector);

    if (existingTable) {
      existingTable.remove();
    }

    wrapper.classList.remove('pc-fitment-transposed-ready');

    const sourceRows = Array.from(sourceTable.querySelectorAll('tr'));
    const headerRow = sourceRows.find((row) => row.querySelector('th'));
    const dataRows = sourceRows.filter((row) => row.querySelector('td'));

    if (!headerRow || !dataRows.length) return;

    const headers = Array.from(headerRow.querySelectorAll('th')).map((header) =>
      header.textContent.trim()
    );

    const rowValues = dataRows.map((row) =>
      Array.from(row.querySelectorAll('td')).map((cell) =>
        cell.textContent.trim()
      )
    );

    const tableWrapper = document.createElement('div');
    tableWrapper.id = 'pc-fitment-transposed-table-wrapper';
    tableWrapper.className = 'pc-fitment-transposed-table-wrapper';

    const transposedTable = document.createElement('table');
    transposedTable.id = 'pc-fitment-transposed-table';
    transposedTable.className = 'pc-fitment-transposed-table';
    transposedTable.setAttribute(
      'aria-label',
      'Compatibility table with vehicle details shown by row'
    );

    const tableBody = document.createElement('tbody');

    headers.forEach((header, columnIndex) => {
      const transposedRow = document.createElement('tr');

      const rowLabel = document.createElement('th');
      rowLabel.scope = 'row';
      rowLabel.textContent = labelMap[header] || header;
      transposedRow.appendChild(rowLabel);

      rowValues.forEach((values) => {
        const cell = document.createElement('td');

        if (values[columnIndex]) {
          cell.textContent = values[columnIndex];
        } else if (fitsAllHeaders.has(header)) {
          cell.classList.add('pc-fitment-fits-all');
        } else {
          cell.textContent = '—';
        }

        transposedRow.appendChild(cell);
      });

      tableBody.appendChild(transposedRow);
    });

    transposedTable.appendChild(tableBody);
    tableWrapper.appendChild(transposedTable);
    wrapper.appendChild(tableWrapper);
    wrapper.classList.add('pc-fitment-transposed-ready');
  };

  let renderTimer;

  const scheduleTransposeRender = () => {
    window.clearTimeout(renderTimer);

    renderTimer = window.setTimeout(() => {
      renderTransposedFitmentTable();
    }, 150);
  };

  const isGeneratedTableChange = (node) => {
    if (node.nodeType !== Node.ELEMENT_NODE) return false;

    return (
      node.matches(generatedTableSelector) ||
      Boolean(node.closest(generatedTableSelector))
    );
  };

  renderTransposedFitmentTable();

  const fitmentObserver = new MutationObserver((mutations) => {
    const fitmentChanged = mutations.some((mutation) => {
      const target =
        mutation.target.nodeType === Node.ELEMENT_NODE
          ? mutation.target
          : mutation.target.parentElement;

      // Ignore our own table being added/removed, preventing a render loop.
      if (target?.closest(generatedTableSelector)) return false;

      const sourceTableChanged = Boolean(target?.closest('#bc-applications'));

      const relevantElementWasAdded = Array.from(mutation.addedNodes).some(
        (node) =>
          node.nodeType === Node.ELEMENT_NODE &&
          !isGeneratedTableChange(node) &&
          (node.matches('#Applications, #bc-applications') ||
            node.querySelector('#Applications, #bc-applications'))
      );

      return sourceTableChanged || relevantElementWasAdded;
    });

    if (fitmentChanged) {
      scheduleTransposeRender();
    }
  });

  fitmentObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

// PCFITMENT FILTERS

(() => {
  const mobileBreakpoint = window.matchMedia('(max-width: 749px)');

  const filterState = {
    Year: '',
    Make: '',
    Model: ''
  };

  const labelMap = {
    BodyNumDoors: 'Doors',
    BodyType: 'Body type'
  };

  const fitsAllHeaders = new Set([
    'Submodel',
    'Doors',
    'BodyNumDoors',
    'BodyType',
    'Body Type'
  ]);

  const getFitmentData = () => {
    const sourceTable = document.querySelector('#bc-applications');

    if (!sourceTable) return null;

    const sourceRows = Array.from(sourceTable.querySelectorAll('tr'));
    const headerRow = sourceRows.find((row) => row.querySelector('th'));
    const dataRows = sourceRows.filter((row) => row.querySelector('td'));

    if (!headerRow || !dataRows.length) return null;

    const headers = Array.from(headerRow.querySelectorAll('th')).map((header) =>
      header.textContent.trim()
    );

    const records = dataRows.map((row) => {
      const values = Array.from(row.querySelectorAll('td')).map((cell) =>
        cell.textContent.trim()
      );

      const fields = {};

      headers.forEach((header, index) => {
        fields[header] = values[index] || '';
      });

      return {
        row,
        values,
        fields
      };
    });

    return {
      sourceTable,
      headers,
      records
    };
  };

  const getUniqueValues = (records, field) => {
    return [
      ...new Set(
        records
          .map((record) => record.fields[field])
          .filter(Boolean)
      )
    ].sort((a, b) =>
      a.localeCompare(b, undefined, { numeric: true })
    );
  };

  const setSelectOptions = (select, values, placeholder, selectedValue) => {
    select.innerHTML = '';

    const defaultOption = document.createElement('option');
    defaultOption.value = '';
    defaultOption.textContent = placeholder;
    select.appendChild(defaultOption);

    values.forEach((value) => {
      const option = document.createElement('option');
      option.value = value;
      option.textContent = value;
      option.selected = value === selectedValue;
      select.appendChild(option);
    });

    select.disabled = values.length === 0;
  };

  const recordMatches = (record) => {
    return Object.entries(filterState).every(([field, selectedValue]) => {
      return !selectedValue || record.fields[field] === selectedValue;
    });
  };

  const renderMobileTransposedTable = (headers, records) => {
    const fitmentWrapper = document.querySelector('#fitmentApplicationsWrapper');

    if (!fitmentWrapper) return;

    const existingTable = fitmentWrapper.querySelector(
      '#pc-fitment-transposed-table-wrapper'
    );

    if (existingTable) {
      existingTable.remove();
    }

    fitmentWrapper.classList.remove('pc-fitment-transposed-ready');

    if (!mobileBreakpoint.matches) return;

    const tableWrapper = document.createElement('div');
    tableWrapper.id = 'pc-fitment-transposed-table-wrapper';
    tableWrapper.className = 'pc-fitment-transposed-table-wrapper';

    if (!records.length) {
      const emptyMessage = document.createElement('p');
      emptyMessage.className = 'pc-fitment-transposed-empty';
      emptyMessage.textContent =
        'No fitments match the filters you selected.';

      tableWrapper.appendChild(emptyMessage);
      fitmentWrapper.appendChild(tableWrapper);
      fitmentWrapper.classList.add('pc-fitment-transposed-ready');
      return;
    }

    const transposedTable = document.createElement('table');
    transposedTable.className = 'pc-fitment-transposed-table';
    transposedTable.setAttribute(
      'aria-label',
      'Filtered compatibility table'
    );

    const tableBody = document.createElement('tbody');

    headers.forEach((header, columnIndex) => {
      const transposedRow = document.createElement('tr');

      const rowLabel = document.createElement('th');
      rowLabel.scope = 'row';
      rowLabel.textContent = labelMap[header] || header;

      transposedRow.appendChild(rowLabel);

      records.forEach((record) => {
        const cell = document.createElement('td');

        if (record.values[columnIndex]) {
          cell.textContent = record.values[columnIndex];
        } else if (fitsAllHeaders.has(header)) {
          cell.classList.add('pc-fitment-fits-all');
        } else {
          cell.textContent = '—';
        }

        transposedRow.appendChild(cell);
      });

      tableBody.appendChild(transposedRow);
    });

    transposedTable.appendChild(tableBody);
    tableWrapper.appendChild(transposedTable);
    fitmentWrapper.appendChild(tableWrapper);
    fitmentWrapper.classList.add('pc-fitment-transposed-ready');
  };

  const refreshFitments = () => {
    const fitmentData = getFitmentData();
    const filterBar = document.querySelector('[data-fitment-filters]');

    if (!fitmentData || !filterBar) return;

    const { headers, records } = fitmentData;

    const yearSelect = filterBar.querySelector(
      '[data-fitment-filter="Year"]'
    );
    const makeSelect = filterBar.querySelector(
      '[data-fitment-filter="Make"]'
    );
    const modelSelect = filterBar.querySelector(
      '[data-fitment-filter="Model"]'
    );
    const count = filterBar.querySelector('[data-fitment-count]');

    const years = getUniqueValues(records, 'Year');

    if (filterState.Year && !years.includes(filterState.Year)) {
      filterState.Year = '';
      filterState.Make = '';
      filterState.Model = '';
    }

    const recordsForMake = records.filter(
      (record) =>
        !filterState.Year || record.fields.Year === filterState.Year
    );

    const makes = getUniqueValues(recordsForMake, 'Make');

    if (filterState.Make && !makes.includes(filterState.Make)) {
      filterState.Make = '';
      filterState.Model = '';
    }

    const recordsForModel = recordsForMake.filter(
      (record) =>
        !filterState.Make || record.fields.Make === filterState.Make
    );

    const models = getUniqueValues(recordsForModel, 'Model');

    if (filterState.Model && !models.includes(filterState.Model)) {
      filterState.Model = '';
    }

    setSelectOptions(yearSelect, years, 'Year', filterState.Year);
    setSelectOptions(makeSelect, makes, 'Make', filterState.Make);
    setSelectOptions(modelSelect, models, 'Model', filterState.Model);

    const filteredRecords = records.filter(recordMatches);

    records.forEach((record) => {
      record.row.style.display = recordMatches(record) ? '' : 'none';
    });

    count.textContent =
      filteredRecords.length === records.length
        ? `${records.length.toLocaleString()} compatible fitments`
        : `Showing ${filteredRecords.length.toLocaleString()} of ${records.length.toLocaleString()} fitments`;

    filterBar.hidden = false;

    renderMobileTransposedTable(headers, filteredRecords);
  };

  const initializeFilterEvents = () => {
    const filterBar = document.querySelector('[data-fitment-filters]');

    if (!filterBar || filterBar.dataset.initialized === 'true') return;

    filterBar.dataset.initialized = 'true';

    filterBar.addEventListener('change', (event) => {
      const field = event.target.dataset.fitmentFilter;

      if (!field) return;

      filterState[field] = event.target.value;

      if (field === 'Year') {
        filterState.Make = '';
        filterState.Model = '';
      }

      if (field === 'Make') {
        filterState.Model = '';
      }

      refreshFitments();
    });

    filterBar
      .querySelector('[data-fitment-reset]')
      .addEventListener('click', () => {
        filterState.Year = '';
        filterState.Make = '';
        filterState.Model = '';

        refreshFitments();
      });
  };

  let refreshTimer;

  const scheduleRefresh = () => {
    window.clearTimeout(refreshTimer);

    refreshTimer = window.setTimeout(() => {
      initializeFilterEvents();
      refreshFitments();
    }, 150);
  };

  initializeFilterEvents();
  scheduleRefresh();

  const fitmentObserver = new MutationObserver((mutations) => {
    const fitmentChanged = mutations.some((mutation) => {
      return (
        mutation.target.nodeType === 1 &&
        mutation.target.closest('#Applications')
      );
    });

    if (fitmentChanged) {
      scheduleRefresh();
    }
  });

  fitmentObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  mobileBreakpoint.addEventListener('change', scheduleRefresh);
})();


// PC FITMENT, Change "Fits Your" to "Potential Fit"

  // (() => {
  //   const updateFitmentMessage = () => {
  //     document.querySelectorAll('.dv-fit-msg').forEach((message) => {
  //       if (message.dataset.potentialMatchUpdated === 'true') return;

  //       const icon = message.querySelector('.nagds-check');

  //       if (icon) {
  //         icon.textContent = 'i';
  //         icon.classList.add('fitment-potential-match-icon');
  //         icon.setAttribute('aria-hidden', 'true');
  //       }

  //       Array.from(message.childNodes).forEach((node) => {
  //         if (node.nodeType === Node.TEXT_NODE) {
  //           node.nodeValue = node.nodeValue.replace(
  //             /Fits\s+Your/i,
  //             'Potential match for your'
  //           );
  //         }
  //       });

  //       message.classList.add('fitment-potential-match');
  //       message.dataset.potentialMatchUpdated = 'true';
  //     });
  //   };

  //   document.addEventListener('DOMContentLoaded', updateFitmentMessage);

  //   const observer = new MutationObserver(updateFitmentMessage);

  //   observer.observe(document.body, {
  //     childList: true,
  //     subtree: true
  //   });
  // })();

  
// Script to transpose table on My Garage Page

  (function () {
    var garage = document.getElementById("garagevehicle");

    if (!garage) {
      return;
    }

    var observer;
    var rebuildTimer;

    function observeGarage() {
      if (!observer) {
        observer = new MutationObserver(function () {
          window.clearTimeout(rebuildTimer);
          rebuildTimer = window.setTimeout(buildMobileGarage, 50);
        });
      }

      observer.observe(garage, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    /*
     * Send clicks from the mobile Actions row to the corresponding
     * controls in the original table.
     */
    function forwardActions(mobileCell, sourceCell) {
      var selector = "a, button, .clsGaragetd2";

      mobileCell.addEventListener(
        "click",
        function (event) {
          var mobileControl = event.target.closest(selector);

          if (!mobileControl || !mobileCell.contains(mobileControl)) {
            return;
          }

          var mobileControls = Array.prototype.slice.call(
            mobileCell.querySelectorAll(selector)
          );

          var sourceControls = sourceCell.querySelectorAll(selector);
          var controlIndex = mobileControls.indexOf(mobileControl);

          if (controlIndex < 0 || !sourceControls[controlIndex]) {
            return;
          }

          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          sourceControls[controlIndex].click();
        },
        true
      );
    }

    function buildMobileGarage() {
      /*
       * Pause observation while rebuilding so the generated mobile
       * table doesn't cause an endless rebuild loop.
       */
      if (observer) {
        observer.disconnect();
      }

      var existingMobileCard =
        garage.querySelector(".garage-mobile-card");

      if (existingMobileCard) {
        existingMobileCard.remove();
      }

      var sourceTable =
        garage.querySelector("#garage-applications");

      var headerRow =
        sourceTable && sourceTable.tHead
          ? sourceTable.tHead.rows[0]
          : null;

      var sourceBody =
        sourceTable && sourceTable.tBodies.length
          ? sourceTable.tBodies[0]
          : null;

      /*
       * The garage table may be loaded after the page. Continue
       * watching until it becomes available.
       */
      if (!headerRow || !sourceBody) {
        observeGarage();
        return;
      }

      var headers =
        Array.prototype.slice.call(headerRow.cells);

      var vehicles =
        Array.prototype.slice
          .call(sourceBody.rows)
          .filter(function (row) {
            return row.cells.length > 0;
          });

      if (!headers.length || !vehicles.length) {
        observeGarage();
        return;
      }

      var card = document.createElement("div");
      card.className = "garage-mobile-card";

      var hint = document.createElement("div");
      hint.className = "garage-mobile-hint";
      hint.innerHTML =
        "<span>Swipe right to see more compatible vehicles</span>" +
        '<span class="garage-mobile-hint__arrow" aria-hidden="true">&rarr;</span>';

      var scroll = document.createElement("div");
      scroll.className = "garage-mobile-scroll";
      scroll.setAttribute("tabindex", "0");
      scroll.setAttribute("role", "region");
      scroll.setAttribute("aria-label", "Saved vehicles");

      var mobileTable = document.createElement("table");
      mobileTable.className = "garage-mobile-table";

      var mobileBody = document.createElement("tbody");

      /*
       * Each original header becomes a row label.
       * Each original vehicle row becomes a vehicle column.
       */
      headers.forEach(function (header, fieldIndex) {
        var mobileRow = document.createElement("tr");

        var label = document.createElement("th");
        label.setAttribute("scope", "row");
        label.textContent = header.textContent.trim();

        mobileRow.appendChild(label);

        vehicles.forEach(function (vehicle) {
          var sourceCell = vehicle.cells[fieldIndex];

          var mobileCell = sourceCell
            ? sourceCell.cloneNode(true)
            : document.createElement("td");

          /* Prevent duplicate element IDs. */
          mobileCell.removeAttribute("id");

          mobileCell
            .querySelectorAll("[id]")
            .forEach(function (element) {
              element.removeAttribute("id");
            });

          /*
           * The final original column is Actions, so it becomes
           * the final row in the transposed table.
           */
          if (
            sourceCell &&
            fieldIndex === headers.length - 1
          ) {
            forwardActions(mobileCell, sourceCell);
          }

          mobileRow.appendChild(mobileCell);
        });

        mobileBody.appendChild(mobileRow);
      });

      mobileTable.appendChild(mobileBody);
      scroll.appendChild(mobileTable);
      card.appendChild(hint);
      card.appendChild(scroll);
      garage.appendChild(card);

      observeGarage();
    }

    observeGarage();
    buildMobileGarage();
  })();

// CODE FOR PCFITMENT SEARCH RESULTS CARDS

(() => {
  if (window.nagdFitmentMetafieldsLoaded) return;
  window.nagdFitmentMetafieldsLoaded = true;

  const cardSelector = ".pc-search-result-newpage .grid-item_pc";
  const cache = new Map();
  const states = new WeakMap();
  const queue = [];
  let active = 0;
  let scheduled = false;

  function limited(task) {
    return new Promise((resolve, reject) => {
      queue.push({ task, resolve, reject });
      drain();
    });
  }

  function drain() {
    while (active < 4 && queue.length) {
      const job = queue.shift();
      active++;

      Promise.resolve()
        .then(job.task)
        .then(job.resolve, job.reject)
        .finally(() => {
          active--;
          drain();
        });
    }
  }

  function productUrl(card) {
    const link = card.querySelector(".card-heading a");
    if (!link) return null;

    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin) return null;
    if (!url.pathname.includes("/products/")) return null;

    url.search = "";
    url.hash = "";
    const variantId = card.querySelector(
      'form[action*="/cart/add"] input[name="id"]'
    )?.value;
    if (variantId) {
      url.searchParams.set("variant", variantId);
    }
    url.searchParams.set("section_id", "nagd-card-metafields");
    return url.href;
  }

  function loadDetails(url) {
    if (!cache.has(url)) {
      const request = limited(async () => {
        const response = await fetch(url, {
          credentials: "same-origin"
        });

        if (!response.ok) {
          throw new Error(`Product details returned ${response.status}`);
        }

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, "text/html");
        const details = doc.querySelector(".nagd-fitment-meta");

        if (!details) {
          throw new Error("Metafield section was not returned");
        }

        return details;
      });

      cache.set(url, request);
      request.catch(() => cache.delete(url));
    }

    return cache.get(url);
  }

function updateCartButton(card, details) {
  // Place shipping benefits below the price without adding duplicates.
  const priceRow = card.querySelector(".card-footer");
  const shippingTemplate = details?.querySelector(
    ".nagd-fitment-shipping-template"
  );
  const shippingContent = shippingTemplate?.content?.firstElementChild;

  if (priceRow && shippingContent) {
    let shipping = card.querySelector(".nagd-fitment-shipping");

    if (!shipping) {
      shipping = shippingContent.cloneNode(true);
    }

    // Restore the position if PC Fitment rebuilds the price area.
    if (priceRow.nextElementSibling !== shipping) {
      priceRow.insertAdjacentElement("afterend", shipping);
    }
  }

  // Use the card variant's availability to control its purchase button.
  const availability = details?.getAttribute("data-variant-available");
  if (availability !== "true" && availability !== "false") return;

  const unavailable = availability === "false";
  const button = card.querySelector(".btnaddtocart");
  if (!button) return;

  const label = unavailable ? "Out of stock" : "Add to cart";

  // Only change values when necessary to avoid observer loops.
  if (button.disabled !== unavailable) {
    button.disabled = unavailable;
  }

  if (button.getAttribute("aria-disabled") !== String(unavailable)) {
    button.setAttribute("aria-disabled", String(unavailable));
  }

  if (button.title !== label) {
    button.title = label;
  }

  const text = button.querySelector("span") || button;
  if (text.textContent !== label) {
    text.textContent = label;
  }
}

  async function enhance(card) {
    const url = productUrl(card);
    const target = card.querySelector(".card-info");
    if (!url || !target) return;

    const previous = states.get(card);
    const existing = target.querySelector(".nagd-fitment-meta");

    if (previous?.url === url && previous.target === target) {
      if (previous.status === "pending") return;
      if (previous.status === "error") return;

      if (previous.status === "done" && existing) {
        // Also handles PC Fitment replacing just the purchase button.
        updateCartButton(card, existing);
        return;
      }
    }

    existing?.remove();

    const state = { url, target, status: "pending" };
    states.set(card, state);

    try {
      const details = await loadDetails(url);

      // Ignore results for cards that have since changed.
      if (
        !card.isConnected ||
        states.get(card) !== state ||
        productUrl(card) !== url ||
        card.querySelector(".card-info") !== target
      ) return;

      const insertedDetails = details.cloneNode(true);
      target.append(insertedDetails);
      updateCartButton(card, insertedDetails);
      state.status = "done";
    } catch (error) {
      state.status = "error";
      console.warn("NAGD metafields:", error.message);
    }
  }

  function scan() {
    scheduled = false;
    document.querySelectorAll(cardSelector).forEach(enhance);
  }

  function scheduleScan() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(scan);
  }

  function start() {
    // Observe a stable ancestor because PC Fitment may replace its grid.
    const root = document.querySelector("main") || document.body;

    new MutationObserver(scheduleScan).observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["href"]
    });

    scan();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();


(() => {
  function highlightShipping() {
    document.querySelectorAll(
      'nagd-benefits-bar .nagd-benefits__item'
    ).forEach(item => {
      if (item.querySelector('.nagd-shipping-highlight')) return;

      const label = item.querySelector('a, span');
      if (!label) return;

      const text = label.textContent;
      const match = /FREE\s+SHIPPING\s*\+\s*NO\s+HANDLING\s+FEES/i.exec(text);
      if (!match) return;

      const highlight = document.createElement('span');
      highlight.className = 'nagd-shipping-highlight';
      highlight.textContent = match[0];

      label.replaceChildren(
        document.createTextNode(text.slice(0, match.index)),
        highlight,
        document.createTextNode(text.slice(match.index + match[0].length))
      );
    });
  }

  highlightShipping();
  document.addEventListener('DOMContentLoaded', highlightShipping);
  document.addEventListener('shopify:section:load', highlightShipping);
})();

// SIKA NAVBAR STYLING
 (() => {
    function addSikaNavLogo() {
      const links = document.querySelectorAll(
        '#header a[href="/collections/sika"]'
      );

      links.forEach((link) => {
        // Prevent duplicate logos if this runs again.
        if (link.querySelector('.sika-nav-logo')) return;

        const logo = document.createElement('img');
        logo.src =
          'https://cdn.shopify.com/s/files/1/1806/8367/files/Sika_PNG.png';
        logo.className = 'sika-nav-logo';
        logo.width = 35;
        logo.height = 35;

        // The link text already identifies Sika.
        logo.alt = '';
        logo.setAttribute('aria-hidden', 'true');

        link.classList.add('sika-nav-link');
        link.prepend(logo);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', addSikaNavLogo, {
        once: true
      });
    } else {
      addSikaNavLogo();
    }

    // Reapply when Shopify's theme editor reloads a section.
    document.addEventListener('shopify:section:load', addSikaNavLogo);
  })();